export const listPlaybooks = `
   query listPlaybooks($filter: PlaybooksFilterInput, $limit: Int, $nextToken:  String) {
       listPlaybooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              name
              displayName
              description
              stateMachineArn
              inputSchema
              category
              status
              createdByUsername
              created
              updated
           }
       }
   }
`;

export const getPlaybook = `
   query getPlaybook($id:ID!) {
       getPlaybook(id:$id) {
         id
         name
         displayName
         description
         stateMachineArn
         inputSchema
         category
         status
         createdByUsername
         created
         updated
       }
}`;
